module.exports = __webpack_public_path__ + "img/signup_mobile.6b419c0b.png";